import usePageMeta from '../hooks/usePageMeta';

/**
 * Public leaderboard.
 *
 * DELIBERATELY EMPTY, and blocked on design rather than engineering. There is
 * no game yet — no score, no rounds, no win condition — so nothing produces a
 * result worth ranking, and no `PlayerStats` model exists to hold one.
 *
 * When there is a mechanic, this reads a plain REST endpoint via `apiRequest`,
 * not the socket: match results are cold data and have no business on the 20Hz
 * channel.
 */
function Leaderboard() {
  usePageMeta({
    title: 'Leaderboard',
    description: 'Top players ranked by wins.',
    canonicalPath: '/leaderboard',
  });

  return (
    <div className="min-h-[calc(100vh-5rem)] bg-gray-50 dark:bg-gray-900 py-12">
      <div className="mx-auto max-w-3xl px-6">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Leaderboard</h1>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          Rankings appear here once matches are being recorded.
        </p>

        <div className="mt-8 rounded-xl border border-dashed border-gray-300 dark:border-gray-700 p-12 text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            No matches played yet.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Leaderboard;
